import { render, staticRenderFns } from "./InputLayout.vue?vue&type=template&id=318d9cf6"
import script from "./InputLayout.vue?vue&type=script&lang=js"
export * from "./InputLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports